export const hi = {
  upload: "अपलोड",
  cancel: "रद्द करना",
  close: "बंद करे",
  uploading: "अपलोड हो रहा है...",
  uploaded: "अपलोड हो गया",
  fetching: "हम आपकी तस्वीर $1$ से ला रहे हैं...",
  poweredBy: "$1$ द्वारा संचालित",
  needHelp: "मदद चाहिए?",
  units: {
    px: "पिक्सेल",
    "%": "प्रतिशत",
    deg: "डिग्री",
  },
  errors: {
    response_not_ok: "आपकी फ़ाइल लाने में एक त्रुटि हुई",
    unable_to_search: "ढूंढे में एक त्रुटि हुई",
    invalid_service_url: "यह एक $1$ यूआरएल नहीं है",
    invalid_url: "यह यूआरएल गलत है",
    upload_aborted: "आपका अपलोड रद्द हो गया है",
    upload_error: "आपका अपलोड कारसे टूट एक त्रुटि हुई",
    file_type_not_allowed: "यह फाइल टाइप अनुमति नहीं हैं",
    file_too_large: "आपकी फाइल $1$ से छोटी होनी चाहिए",
  },
  help: {
    loading: "मदद लोड हो रही है...",
    close: "मदद बंद करें",
  },
  services: {
    default: {
      heading: "एक तस्वीर चुनें",
    },
    local: {
      title: "एक फाइल चुनें",
      button: "फाइल चुनें",
      or: "या",
      drop: "यहां फाइल छोड़ें",
    },
    camera: {
      title: "कैमरा",
      button: "तस्वीर खीचें",
      switch: "कैमरा बदलें",
      waiting: "अनुमति की प्रतीक्षा की जा रही है...",
      unableToRead:
        "हम आपका वीडियो नहीं पढ़ पा रहे हैं I यह इसीलिए हो सकता है क्यूंकि आपने अनुमति नहीं दी, या क्योंकि आपके युक्ति में कैमरा नहीं है I",
    },
    microlink: {
      button: "$1$ से आयात",
      label: "$1$ $2$ यूआरएल",
      placeholder: "एक $1$ $2$ यूआरएल दर्ज करें",
      type: "पद",
    },
    url: {
      title: "यूआरएल",
      label: "छवि यूआरएल",
      placeholder: "एक छवि यूआरएल दर्ज करें",
    },
    instagram: {
      title: "इंस्टाग्राम",
    },
    facebook: {
      title: "फेसबुक",
    },
    flickr: {
      title: "फ़्लिकर",
      type: "तस्वीर",
    },
    ninegag: {
      title: "नाइन गैग",
      type: "तस्वीर",
    },
    deviantart: {
      title: "देवीअनत-आर्ट",
    },
    artstation: {
      title: "आर्ट-स्टेशन",
    },
    twitter: {
      title: "ट्विटर",
      type: "तस्वीर ट्वीट",
    },
    pinterest: {
      title: "पिनटेरेस्ट",
      type: "पिन",
    },
    flipboard: {
      title: "फ्लिपबोर्ड",
      type: "लेख",
    },
    fotki: {
      title: "फोटकी",
      type: "तस्वीर",
    },
    linkedin: {
      title: "लिंक्ड-इन",
    },
    reddit: {
      title: "रेड्डिट",
    },
    tumblr: {
      title: "तुमब्लर",
    },
    weheartit: {
      title: "वी हार्ट इट",
    },
    screenshot: {
      title: "स्क्रीनशॉट",
      button: "स्क्रीनशॉट लें",
      label: "वेब पृष्ठ यूआरएल",
      placeholder: "एक वेब पृष्ठ यूआरएल दर्ज करें",
      loading: "स्क्रीनशॉट लिया जा रहा है...",
    },
    search: {
      button: "$1$ पर ढूंढें",
      label: "तस्वीर ढूंढें",
      placeholder: "कुछ ढूंढें",
      imagesPoweredBy: "तस्वीरें $1$ द्वारा संचालित",
    },
    giphy: {
      title: "गिफी",
    },
    unsplash: {
      title: "उनस्प्लैश",
    },
    pixabay: {
      title: "पिक्साबे",
    },
    pexels: {
      title: "पिक्सेल्स",
    },
  },
  effects: {
    preview: {
      title: "पूर्वावलोकन",
    },
    filters: {
      title: "फ़िल्टर",
    },
    crop: {
      title: "क्रॉप",
      aspectRatios: {
        free: "फ़्री",
        square: "वर्ग",
      },
    },
    rotate: {
      title: "घुमाएँ",
    },
    flip: {
      title: "फ्लिप",
      buttons: {
        horizontal: "क्षैतिज",
        vertical: "खड़ा",
      },
    },
    sharpen: {
      title: "पैना",
    },
    blur: {
      title: "कलंक",
    },
    brightness: {
      title: "चमक",
    },
    contrast: {
      title: "कंट्रास्ट",
    },
    grayscale: {
      title: "ग्रेस्केल",
    },
    "hue-rotate": {
      title: "रंग घुमाना",
    },
    invert: {
      title: "रंग पलटना",
    },
    saturate: {
      title: "सैच्युरेट",
    },
    sepia: {
      title: "सीपिया",
    },
  },
};
